// modified to use ES6 syntax from
// https://github.com/mixpanel/analytics/blob/c3e88f6/media/js/reports/notifications/util/dragging.js
//
// adapted from sortablejs v1.5.1: https://www.npmjs.com/package/sortablejs
// https://github.com/RubaXa/Sortable/blob/473bd8f/Sortable.js#L1364-L1378
// https://github.com/RubaXa/Sortable/blob/473bd8f/Sortable.js#L1167-L1171
// https://github.com/RubaXa/Sortable/blob/473bd8f/Sortable.js#L1151-L1164

const matches = (el, selector) => {
  if (el) {
    selector = selector.split(`.`);
    const tag = selector.shift().toUpperCase();
    const re = new RegExp(`\\s(${selector.join(`|`)})(?=\\s)`, `g`);
    return (
      (tag === `` || el.nodeName.toUpperCase() === tag) &&
      (!selector.length || (` ${el.className} `.match(re) || []).length === selector.length)
    );
  }
  return false;
};

const getParentOrHost = (el) => {
  const parent = el.host;
  return parent && parent.nodeType ? parent : el.parentNode;
};

export const closestEl = (el, selector, ctx) => {
  if (el) {
    ctx = ctx || document;
    do {
      if ((selector === `>*` && el.parentNode === ctx) || matches(el, selector)) {
        return el;
      }
      /* eslint "no-cond-assign": 0 */
    } while ((el = getParentOrHost(el)));
  }
  return null;
};
